import {InjectionToken} from '@angular/core';

// Tokens to configure HTTP behavior application‑wide. Keeping them as tokens
// allows easy overrides in tests or environment‑specific provider setups.

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const API_RETRY_COUNT = new InjectionToken<number>('API_RETRY_COUNT');
export const API_RETRY_DELAY_MS = new InjectionToken<number>('API_RETRY_DELAY_MS');


